import React from "react";
import styles from "./Decks.module.sass";
import TableComponent from "../../../../../components/TableComponent";
import { BiPlus } from "react-icons/bi";
import useState from "react-usestateref";
import { useSelector } from "react-redux";
import { useEffect, useMemo } from "react";
import Modal from "../../../../../components/Modal";

const columns = [
  {
    header: "Deck name",
    accessor: "deckName",
  },
  {
    header: "Level",
    accessor: "level",
  },
  {
    header: "Actions",
    accessor: "actions",
  },
];

const Decks = ({ decksSelected, setDecksSelected, isEdit, availableDecks }) => {
  const { decks } = useSelector((state) => state);
  const allDecksSource = availableDecks?.length ? availableDecks : decks?.value;
  const getDeckId = (deck) => (typeof deck === "string" ? deck : deck?._id || deck?.sourceId || null);
  const isSelectableAdminDeck = (deck) => {
    if (!deck || typeof deck === "string") return false;
    const role = String(deck?.role || "").toUpperCase();
    const hasInvitations = Array.isArray(deck?.invitations) && deck.invitations.length > 0;
    const hasClassRooms = Array.isArray(deck?.classRooms) && deck.classRooms.length > 0;
    if (role && role !== "ADMIN") return false;
    return !hasInvitations && !hasClassRooms;
  };
  const selectableDecksSource = useMemo(
    () => (allDecksSource || []).filter(isSelectableAdminDeck),
    [allDecksSource]
  );

  const [visibleModal, setVisibleModal] = useState(false);
  const [decksTable, setDecksTable] = useState([]);

  const [deckTable, setDeckTable, deckTableRef] = useState([]);

  useEffect(() => {
    if (isEdit && decksSelected && deckTable.length === 0) {
      let _deck = [];

      decksSelected?.forEach((c) => {
        const deckId = getDeckId(c);
        const sourceDeck =
          typeof c === "string"
            ? allDecksSource?.find((deck) => String(getDeckId(deck)) === String(deckId))
            : c;
        _deck.push(
          handleParseDataDeck(
            sourceDeck || {
              _id: deckId,
              title: "-",
              level: "-",
            }
          )
        );
      });

      if (_deck.length > 0) {
        setDeckTable(_deck);
      }
    }
  }, [isEdit, decksSelected, deckTable, allDecksSource]);

  const handleParseDataDeck = (deck) => {
    return {
      deckName: {
        data: deck?.title,
        dataComponent: deck?.title,
      },
      level: {
        data: deck?.level || "-",
        dataComponent: deck?.level || "-",
      },
      _id: getDeckId(deck),
      actions: {
        data: "actions",
        dataComponent: (
          <div style={{ display: "flex", alignItems: "center" }}>
            <button className={styles.linkAction} onClick={() => window.open(`/deck/edit/${getDeckId(deck)}`, "_blank")}>
              View
            </button>
            <button className={styles.linkActionDanger} onClick={() => handleDeleteDeckTableID(getDeckId(deck))}>
              Delete
            </button>
          </div>
        ),
      },
    };
  };

  const handleDeleteDeckTableID = (id) => {
    setDeckTable((prev) => {
      const filtered = prev?.filter((c) => c._id !== id) ?? [];
      setDecksSelected(filtered?.map((c) => c?._id) ?? []);
      return filtered;
    });
  };

  const handleAddDeckTableID = (deck) => {
    const deckId = getDeckId(deck);
    if (!deckTableRef.current?.find((c) => c._id === deckId)) {
      let _deckTable = [...deckTableRef.current, handleParseDataDeck(deck)];
      setDeckTable(_deckTable);
      setDecksSelected(_deckTable?.map((c) => c?._id));
      setVisibleModal(false);
    }
  };

  useEffect(() => {
    if (selectableDecksSource) {
      setDecksTable(
        selectableDecksSource?.map((deck) => {
          return {
            deckName: {
              data: deck?.title,
              dataComponent: deck?.title,
            },
            level: {
              data: deck?.level || "-",
              dataComponent: deck?.level || "-",
            },
            _id: getDeckId(deck),
            actions: {
              data: "actions",
              dataComponent: (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <button className={styles.linkAction} onClick={() => handleAddDeckTableID(deck)} title="Add">
                    <BiPlus size="20" />
                  </button>
                </div>
              ),
            },
          };
        })
      );
    }
  }, [selectableDecksSource]);

  const handleShowModalAddDeck = () => {
    setVisibleModal(true);
  };

  return (
    <div>
      <Modal outerClassName={styles.outer} visible={visibleModal} onClose={() => setVisibleModal(false)}>
        <div className={styles.modalContent}>
          <TableComponent className={styles.decksModal} tableClassName={styles.decksTable} title="decks" data={decksTable} columns={columns} embedded isCardStyle={false} />
        </div>
      </Modal>
      <TableComponent
        data={deckTable}
        columns={columns}
        isButton={true}
        buttonText="Add Deck"
        buttonIcon={<BiPlus size="24" />}
        buttonHandler={handleShowModalAddDeck}
        title="Decks"
      />
    </div>
  );
};

export default Decks;
